export const StandingPlaceDynamic = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="6" r="3" stroke="currentColor" stroke-width="2"/>
<path d="M20 21H19V29C19 29.5523 18.5523 30 18 30H14C13.4477 30 13 29.5523 13 29V21H12C11.4477 21 11 20.5523 11 20V14C11 12.8954 11.8954 12 13 12H19C20.1046 12 21 12.8954 21 14V20C21 20.5523 20.5523 21 20 21Z" stroke="currentColor" stroke-width="2"/>
</svg>`;
